<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-bell"></i> 公告列表 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                >
                <!-- <el-select v-model="bar"  placeholder="公告" class="handle-select mr10" @change="selectValue">
                    <el-option value="普通公告"></el-option>
                    <el-option value="系统公告"></el-option>
                </el-select> -->
                <el-radio-group v-model="bar" class="mr10" @change="selectValue">
                    <!-- <el-radio-button label="普通公告"></el-radio-button> -->
                    <!-- <el-radio-button label="系统公告"></el-radio-button> -->
                </el-radio-group>
                <el-input v-model="name" clearable placeholder="请输入标题" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float: right" type="primary" icon="el-icon-plus" @click="handleAdd" v-if="perData.allow_add == 1"
                    >添加</el-button
                >
            </div>
            <el-table
                :data="tableData"
                @sort-change="sortMethod"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="title" fixed="left" label="标题" align="center">
                    <template slot-scope="scope">
                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="content" label="内容" width="100" align="center"></el-table-column> -->
                <el-table-column prop="staffr_name" label="发布人" width="120" align="center"></el-table-column>
                <el-table-column prop="send_addtime" label="发布时间" width="160" align="center"></el-table-column>
                <el-table-column prop="count_read_count" label="未读人数" width="120" align="center" sortable="custom"></el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    width="300"
                    align="center"
                    v-if="perData.allow_edit == 1 || perData.allow_dele == 1 || perbtnData.allow_use == 1"
                >
                    <template slot-scope="scope">
                        <el-button type="primary" plain icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                            >查看详情</el-button
                        >
                        <el-button type="danger" icon="el-icon-delete" plain v-if="perData.allow_dele == 1" @click="handleDelete(scope)"
                            >{{ $t('common.delete') }}</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 添加弹出框 -->
        <el-dialog title="添加" :visible.sync="addData.isshow" width="50%">
            <el-form label-width="100px">
                <el-form-item label="系统：" v-if="$bus.type === '开发版'">
                    <el-select style="width: 100%" v-model="addData.data.sys_type" placeholder="请选择类型" @change="refreshs()">
                        <el-option v-for="(item, index) in allSelect.sys_type" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型：">
                    <el-select style="width: 100%" v-model="addData.data.send_type" placeholder="请选择类型" @change="refreshs()">
                        <el-option
                            v-for="(item, index) in allSelect.send_type"
                            :key="index"
                            :label="item.kind_name"
                            :value="item.kind_no"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="addData.data.send_type == '部门' || addData.data.send_type == '个人'" label="接收：">
                    <el-select
                        style="width: 100%"
                        v-model="addData.data.receive_no"
                        placeholder="请选择"
                        v-if="addData.data.send_type == '部门'"
                    >
                        <el-option
                            v-for="(item, index) in allSelect.receive_no"
                            :key="index"
                            :label="item.kind_name"
                            :value="item.kind_no"
                        ></el-option>
                    </el-select>
                    <el-select style="width: 100%" v-model="addData.data.receive_no" placeholder="请选择" v-else>
                        <el-option
                            v-for="(item, index) in allSelect.login_staff_pull"
                            :key="index"
                            :label="item.staffr_name"
                            :value="item.login_staff"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题：">
                    <el-input v-model="addData.data.title"></el-input>
                </el-form-item>
                <el-form-item label="内容：">
                    <el-upload
                        id="quill-upload"
                        ref="upload1"
                        action="apiUpload"
                        :http-request="uploadSectionFile"
                        :show-file-list="false"
                        style="display: none"
                    >
                        <i v-if="!imageUrl" class="el-icon-plus avatar-uploader-icon"></i>
                        <img :src="imageUrl + '?time=' + Date.now()" alt="" class="avatar" />
                    </el-upload>
                    <quill-editor v-model="addData.data.content" ref="myQuillEditor" style="height: 400px" :options="editorOption">
                    </quill-editor>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addData.isshow = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title="详情" :visible.sync="editData.isshow" width="50%">
            <el-form class="editImg" label-width="100px">
                <el-form-item label="发布人：">
                    <span v-text="editData.data.send_user_no || ''"></span>
                </el-form-item>
                <el-form-item label="时间：">
                    <span v-text="editData.data.send_addtime || ''"></span>
                </el-form-item>
                <el-form-item label="类型：">
                    <span v-text="editData.data.send_type || ''"></span>
                </el-form-item>
                <el-form-item label="部门：" v-if="editData.data.receive_name">
                    <span v-text="editData.data.receive_name || ''"></span>
                </el-form-item>
                <el-form-item label="标题：">
                    <span style="font-weight: bold; font-size: 15px" v-text="editData.data.title || ''"></span>
                </el-form-item>
                <el-form-item label="内容：">
                    <span style="overflow: hidden" v-html="editData.data.content || ''"></span>
                    <span style="color: rgb(136, 19, 145); cursor: pointer" @click="clickCheck" v-if="editData.data.url_c">点击查看</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Utils from '../../../assets/util.js';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import { apiNotice, apiNoticeAdd, apiNoticeDetail, apiNoticeDel, apiCurrentPermisson, apiNoticePull, apiUpload } from '@/request/api';
// 工具栏配置
const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ['link', 'image', 'video'],
    ['clean'] // remove formatting button
];
export default {
    name: 'basetable',
    data() {
        return {
            serverUrl: '',
            imageUrl: '',
            uillUpdateImg: false,
            bar: '系统公告',
            name: '',
            headerImage: '',
            picValue: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            allSelect: '',
            selectData: [],
            barData: [],
            studyData: [],
            workData: [],
            perData: '',
            perbtnData: '',
            delList: [],
            editData: { isshow: false, scope: null, index: 0, data: {} },
            addData: { isshow: false, scope: null, index: 0, data: {} },
            pageTotal: 0,
            editorOption: {
                placeholder: '请输入……',
                modules: {
                    toolbar: {
                        container: toolbarOptions, // 工具栏
                        handlers: {
                            image: function(value) {
                                if (value) {
                                    document.querySelector('#quill-upload input').click();
                                } else {
                                    this.quill.format('image', false);
                                }
                            }
                        }
                    }
                }
            },
            order_read: '',
            isAdmin: false
        };
    },
    components: {
        quillEditor
    },
    computed: {
        headers() {
            return {
                Authorization: 'Bearer ' + sessionStorage.getItem('userToken')
            };
        }
    },
    created() {
        this.getData();
        this.getSelectData();
        this.getPermission();
    },
    activated() {
        this.getData();
        this.getSelectData();
        this.getPermission();
        // this.isAdmin = localStorage.getItem('ms_username') == 'administrator' && this.$bus.data.type == '开发版';
        //
        // if (this.$route.params) this.handleEdit(null, this.$route.params.id);
    },
    methods: {
        // 获取列表信息
        getData() {
            apiNotice({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name,
                type: this.bar,
                order_read: this.order_read
            }).then(res => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取下拉列表信息
        getSelectData() {
            apiNoticePull({}).then(res => {
                if (res.code == 2000) {
                    this.allSelect = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '53'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 未读排序方法
        sortMethod({ order }) {
            if (order == 'ascending') this.order_read = '倒序';
            else if (order == 'descending') this.order_read = '顺序';
            else this.order_read = '';
            this.getData();
        },
        // 详情 ->拼接内容 点击查看
        clickCheck() {
            this.$set(this.editData, 'isshow', false);
            const { url_c } = this.editData.data;
            this.$router.push({ name: url_c.url_c, params: url_c.params });
        },
        // 触发搜索按钮---------------------------------------------------------------
        selectValue() {
            this.getData();
        },
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData.isshow = true;
            this.addData.data = {};
        },
        saveAdd() {
            let data = this.addData.data;
            apiNoticeAdd(data).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addData.isshow = false;
                    this.getData();
                    Utils.$emit('demo', 'msg');
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 删除操作---------------------------------------------------------------
        handleDelete({ row }) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiNoticeDel({
                        id: row.id
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                            Utils.$emit('demo', 'msg');
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function(item, index, array) {
                arr.push(item.id);
            });
            this.delList = arr;
        },
        delAllSelection() {
            if (this.delList.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            this.$confirm('此操作将批量删除, 是否继续?', '批量删除提示', {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    apiNoticeDel({
                        id: this.delList.join(',')
                    }).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                            Utils.$emit('demo', 'msg');
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                    // this.$message({ type: 'info',  message: '已取消删除' });
                });
        },
        // 编辑操作----------------------------------------------------------------------
        handleEdit(scope, ids) {
            let id = '';
            // if (ids) id = ids;
            // else
            id = scope.row.id;
            this.editData.isshow = true;
            apiNoticeDetail({ id: id, send_type: this.$bus.data.type }).then(res => {
                if (res.code == 2000) this.$set(this.editData, 'data', res.data);
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.getData();
        },
        refreshs() {
            this.$forceUpdate();
        },
        uploadSectionFile(f) {
            //	附件上传
            let self = this;
            let Orientation;
            let ndata;
            if (f.file.size <= 1 * 1024 * 1024) {
                //判断图片是否大于1M,是就直接上传
                ndata = f.file;
                self.postImg(ndata);
            } else {
                //反之压缩图片
                let reader = new FileReader();
                // 将图片2将转成 base64 格式
                reader.readAsDataURL(f.file);

                // 读取成功后的回调
                reader.onloadend = function() {
                    let result = this.result;
                    let img = new Image();
                    img.src = result;
                    img.onload = function() {
                        let data = self.compress(img, Orientation);
                        self.headerImage = data;
                        ndata = self.compress(img, Orientation);

                        //BASE64转图片
                        var arr = ndata.split(','),
                            mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]),
                            n = bstr.length,
                            u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        ndata = new File([u8arr], f.file.name, { type: mime });
                        self.postImg(ndata);
                    };
                };
            }
        },
        async postImg(ndata) {
            let param = new FormData(); //创建form对象
            param.append('file', ndata); //通过append向form对象添加数据
            param.append('url', 'stylesec'); //文件夹名
            //   param.append('name', '123');//文件名
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            try {
                const response = await apiUpload(param, config); //此处写接口对应的vue方法
                if (response.code == 2000) {
                    this.$refs.upload1.clearFiles();
                    this.imageUrl = response.data.imgs;
                    let quill = this.$refs.myQuillEditor.quill;
                    let length = quill.getSelection().index;
                    quill.insertEmbed(length, 'image', response.data.imgs);
                    // 调整光标到最后
                    quill.setSelection(length + 1);
                    // this.imgs1=response.data.img
                }
            } catch (error) {}
        },
        compress(img, Orientation) {
            let canvas = document.createElement('canvas');
            let ctx = canvas.getContext('2d');
            //瓦片canvas
            let tCanvas = document.createElement('canvas');
            let tctx = tCanvas.getContext('2d');
            let initSize = img.src.length;
            let width = img.width;
            let height = img.height;
            //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
            let ratio;
            if ((ratio = (width * height) / 4000000) > 1) {
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }
            canvas.width = width;
            canvas.height = height;
            //铺底色
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            //如果图片像素大于100万则使用瓦片绘制
            let count;
            if ((count = (width * height) / 1000000) > 1) {
                count = ~~(Math.sqrt(count) - 1); //计算要分成多少块瓦片
                //计算每块瓦片的宽和高
                let nw = ~~(width / count);
                let nh = ~~(height / count);
                tCanvas.width = nw;
                tCanvas.height = nh;
                for (let i = 0; i < count; i++) {
                    for (let j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }
            //修复ios上传图片的时候 被旋转的问题
            if (Orientation != '' && Orientation != 1) {
                switch (Orientation) {
                    case 6: //需要顺时针（向左）90度旋转
                        this.rotateImg(img, 'left', canvas);
                        break;
                    case 8: //需要逆时针（向右）90度旋转
                        this.rotateImg(img, 'right', canvas);
                        break;
                    case 3: //需要180度旋转
                        this.rotateImg(img, 'right', canvas); //转两次
                        this.rotateImg(img, 'right', canvas);
                        break;
                }
            }
            //进行最小压缩
            let ndata = canvas.toDataURL('image/jpeg', 0.7); //原值0.1 很模糊 值越小越模糊，越大越清晰 内存越大

            //

            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;

            return ndata;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.aaa {
    display: flex;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
<style>
.people .el-upload {
    width: 178px;
    height: 178px;
}
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.ql-container {
    height: 300px;
    min-height: 300px;
}
.editImg img {
    width: 100%;
}
</style>
